import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
    Box,
    Stack,
    useToast
} from '@chakra-ui/react';
import Form from '@rjsf/chakra-ui';
import validator from "@rjsf/validator-ajv8";
import { reverseTransformData } from '../../util/helper';
import { createNewCountry, getCountryData, updateCountryData } from '../../services/Countries';
import { handleApiError, showSuccessToast } from '../../util/errorHandler';

const Country = () => {

    const { alias } = useParams();
    const [processedData, setProcessedData] = useState({});
    const [quickSave, setQuickSave] = useState(false);
    const toast = useToast();
    const navigate = useNavigate();

    const schema = {
        "title": "Country Fields",
        "description": "",
        "type": "object",
        "properties": {
            "name": {
                "type": "string",
                "title": "Name",
                "default": ""
            },
            "alias": {
                "type": "string",
                "title": "Alias",
                "default": ""
            },
            "masterlist_subtype": {
                "type": "string",
                "title": "Masterlist Subtype",
                "default": ""
            },

        },
        required: ['name', 'alias']
    };

    const uiSchema = {
        "ui:submitButtonOptions": {
            "submitText": "Save",
            "norender": false,
            "props": {
                "disabled": false,
                "className": "button button--primary button--blue",
                "loadingText": "Saving..",
                "colorScheme": "teal"
            }
        },
        name: {
            'ui:emptyValue': ''
        },
        alias: {
            'ui:emptyValue': '',
            'ui:readonly': !!alias
        },
        masterlist_subtype: {
            'ui:emptyValue': ''
        },
    };

    const formData = processedData;

    // Fetch initial data
    useEffect(() => {
        const getBasicData = async () => {
            try {
                if (alias) {
                    const result = await getCountryData(alias);
                    if (result && result?.data?.[0]) {

                        // To Show image on form need to provide url to image field which is only used to show the image
                        setProcessedData(result?.data?.[0]);
                    }
                }
            } catch (error) {
                handleApiError(error, toast, {
                    defaultErrorMessage: "Failed to fetch data"
                });
            }
        };

        getBasicData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alias, quickSave]);

    // Submit updated data
    const handleSubmit = async (formData) => {

        const updatedFormData = reverseTransformData(formData, []);

        try {
            if (alias) {
                const result = await updateCountryData(alias, updatedFormData);

                if (result?.status === 200) {
                    setQuickSave(prev => !prev);
                    showSuccessToast(toast, "Data updated successfully");
                }
            } else {
                const result = await createNewCountry(updatedFormData);  // Call the create API
                if (result?.status === 201) {
                    setQuickSave(prev => !prev);
                    showSuccessToast(toast, "New country created successfully");
                    navigate(`/countries/${result?.data?.alias}`);  // Navigate to the newly created post
                }
            }
        } catch (error) {
            handleApiError(error, toast);
        }
    };


    return (
        <Stack flexDirection={'row'} gap={"15px"} alignItems={"flex-start"}>
            <Box width={"600px"}>
                <Form
                    schema={schema}
                    uiSchema={uiSchema}
                    formData={formData}
                    validator={validator}
                    onSubmit={(e) => handleSubmit(e.formData)}
                />
            </Box>
        </Stack>
    );
};

export default Country;